<template>
  <div class="estimate">
    <div class="container">
      <div
        v-if="loading"
        class="d-flex justify-content-center pt-5 pb-5 text-muted"
      >
        <font-awesome-icon icon="sync" size="2x" spin />
      </div>
      <div class="heading">
        <h1 style="margin-bottom:10px; font-size:50px;">Estimate My Project</h1>
        <div class="br"></div>
        <p style="font-size:25px;margin-top:10px;">
          Select The Items Below Which Best Describe Your App And The Features
          You Require.
        </p>
        <p style="font-size:18px">
          All Estimates Are Approximate But Should Give You A Rough Idea Of What
          It Will Take To Build Your App.
        </p>
      </div>
      <div
        class="row offset-md-1 offset-xs-1 offset-lg-1 col-xs-10 col-md-10 col-lg-10 offset-md-1 offset-xs-1 offset-lg-1 box-4 mt-5"
      >
        <div class="col-xs-12 col-md-12 col-lg-12 text-center">
          <span class="e_title">Select your Platform(s).</span>
        </div>
        <div
          class="col-xs-4 col-md-4 col-lg-4 box"
          v-for="(type, in_type) in estimate.type"
          :key="in_type"
        >
          <img
            :src="type.img"
            :alt="type.name"
            @click="update_images(type, in_type, 'type')"
          />
        </div>
      </div>
      <div>
        <div
          class="row offset-md-1 offset-xs-1 offset-lg-1 col-xs-10 col-md-10 col-lg-10 offset-md-1 offset-xs-1 offset-lg-1 box-1"
        ></div>
        <div v-for="(other, in_other) in estimate.other" :key="in_other">
          <div
            class="row offset-md-1 offset-xs-1 offset-lg-1 col-xs-10 col-md-10 col-lg-10 offset-md-1 offset-xs-1 offset-lg-1 box-2"
          >
            <div class="col-xs-12 col-md-12 col-lg-12">
              <h1 class="box_heading">{{ in_other + 1 }}. {{ other.name }}</h1>
            </div>
            <div
              class="col-xs-3 col-md-3 col-lg-3 box_other"
              v-for="(other_option, op_type) in other.option"
              :key="op_type"
            >
              <img
                :src="other_option.img"
                :alt="other_option.name"
                @click="update_images(other, in_other, 'other', op_type)"
                class="other_img"
              />
              <p class="img_text">{{ other_option.name }}</p>
            </div>
          </div>
        </div>
        <div
          class="row offset-md-1 offset-xs-1 offset-lg-1 col-xs-10 col-md-10 col-lg-10 offset-md-1 offset-xs-1 offset-lg-1 box-3 form-group"
        >
          <div class="col-xs-4 col-md-4 col-lg-4">
            <input
              type="text"
              class="form-control form-control-lg square"
              placeholder="Enter your name"
              v-model="userdata.name"
              required
            />
            <span v-if="!userdata.name">This field Required</span>
          </div>
          <div class="col-xs-5 col-md-5 col-lg-5">
            <input
              type="email"
              class="form-control form-control-lg square"
              placeholder="Enter your email"
              v-model="userdata.email"
              @input="email_validate"
              required
            />
            <span v-if="!userdata.email">This field Required</span>
            <span v-if="userdata.email && validate.email">Email not Valid</span>
          </div>
          <div class="col-xs-3 col-md-3 col-lg-3">
            <input
              type="number"
              class="form-control form-control-lg square"
              placeholder="Number"
              v-model="userdata.number"
            />
          </div>
          <div
            class="offset-md-8 offset-xs-8 offset-lg-8 col-xs-4 col-md-4 col-lg-4 text-right mt-3"
          >
            <input
              type="button"
              class="btn btn-lg btn-primary from-control square pull-right"
              value="Get Quote"
              style="background-color:#00a8ff"
              @click="submit()"
              :disabled="userdata.email && userdata.name && validate.email"
            />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      title=""
      style="color:#000"
      class="text-center"
      @ok="handleOk"
      ok-only
      centered
    >
      <h5>Thanks {{ userdata.name }} {{ model_text }}</h5>
    </b-modal>
  </div>
</template>

<script>
import { dbFs } from "../modules/database";
export default {
  data() {
    return {
      modalShow: false,
      model_text: " for Query we will connect as soon as posbile",
      loading: false,
      validate: {
        email: true,
        type_selected: false
      },
      userdata: {
        name: "",
        email: ""
      },
      estimate: {
        type: [
          {
            name: "website",
            select: false,
            not_selected: require("../assets/estimate/not-selected/type/1.svg"),
            selected: require("../assets/estimate/selected/type/1.svg"),
            img: require("../assets/estimate/not-selected/type/1.svg")
          },
          {
            name: "IOS",
            select: false,
            not_selected: require("../assets/estimate/not-selected/type/2.svg"),
            selected: require("../assets/estimate/selected/type/2.svg"),
            img: require("../assets/estimate/not-selected/type/2.svg")
          },
          {
            name: "Android",
            select: false,
            not_selected: require("../assets/estimate/not-selected/type/3.svg"),
            selected: require("../assets/estimate/selected/type/3.svg"),
            img: require("../assets/estimate/not-selected/type/3.svg")
          }
        ],
        other: [
          {
            name: "How big is your Company?",
            select_all: false,
            option: [
              {
                name: "Small",
                select: false,
                not_selected: require("../assets/estimate/not-selected/how-big-company/1.svg"),
                selected: require("../assets/estimate/selected/how-big-company/1.svg"),
                img: require("../assets/estimate/not-selected/how-big-company/1.svg")
              },
              {
                name: "Medium",
                select: false,
                not_selected: require("../assets/estimate/not-selected/how-big-company/2.svg"),
                selected: require("../assets/estimate/selected/how-big-company/2.svg"),
                img: require("../assets/estimate/not-selected/how-big-company/2.svg")
              },
              {
                name: "Large",
                select: false,
                not_selected: require("../assets/estimate/not-selected/how-big-company/3.svg"),
                selected: require("../assets/estimate/selected/how-big-company/3.svg"),
                img: require("../assets/estimate/not-selected/how-big-company/3.svg")
              }
            ]
          },
          {
            name: "Do you want custom branding?",
            select_all: false,
            option: [
              {
                name: "Yes",
                select: false,
                not_selected: require("../assets/estimate/not-selected/custom-brand/1.svg"),
                selected: require("../assets/estimate/selected/custom-brand/1.svg"),
                img: require("../assets/estimate/not-selected/custom-brand/1.svg")
              },
              {
                name: "No",
                select: false,
                not_selected: require("../assets/estimate/not-selected/custom-brand/2.svg"),
                selected: require("../assets/estimate/selected/custom-brand/2.svg"),
                img: require("../assets/estimate/not-selected/custom-brand/2.svg")
              }
            ]
          },
          {
            name: "Users & Accounts",
            select_all: true,
            option: [
              {
                name: "E-mail",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/1.svg"),
                selected: require("../assets/estimate/selected/user-account/1.svg"),
                img: require("../assets/estimate/not-selected/user-account/1.svg")
              },
              {
                name: "Facebook",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/2.svg"),
                selected: require("../assets/estimate/selected/user-account/2.svg"),
                img: require("../assets/estimate/not-selected/user-account/2.svg")
              },
              {
                name: "Twitter",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/3.svg"),
                selected: require("../assets/estimate/selected/user-account/3.svg"),
                img: require("../assets/estimate/not-selected/user-account/3.svg")
              },
              {
                name: "Single Sign On",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/4.svg"),
                selected: require("../assets/estimate/selected/user-account/4.svg"),
                img: require("../assets/estimate/not-selected/user-account/4.svg")
              },
              {
                name: "Google Sign Up",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/5.svg"),
                selected: require("../assets/estimate/selected/user-account/5.svg"),
                img: require("../assets/estimate/not-selected/user-account/5.svg")
              },
              {
                name: "Apple",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/6.svg"),
                selected: require("../assets/estimate/selected/user-account/6.svg"),
                img: require("../assets/estimate/not-selected/user-account/6.svg")
              },
              {
                name: "Microsoft",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/7.svg"),
                selected: require("../assets/estimate/selected/user-account/7.svg"),
                img: require("../assets/estimate/not-selected/user-account/7.svg")
              },
              {
                name: "Phone",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-account/8.svg"),
                selected: require("../assets/estimate/selected/user-account/8.svg"),
                img: require("../assets/estimate/not-selected/user-account/8.svg")
              }
            ]
          },
          {
            name: "User Generated Content",
            select_all: true,
            option: [
              {
                name: "Dashboard",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-content/1.svg"),
                selected: require("../assets/estimate/selected/user-content/1.svg"),
                img: require("../assets/estimate/not-selected/user-content/1.svg")
              },
              {
                name: "Activity Feed",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-content/2.svg"),
                selected: require("../assets/estimate/selected/user-content/2.svg"),
                img: require("../assets/estimate/not-selected/user-content/2.svg")
              },
              {
                name: "File Upload",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-content/3.svg"),
                selected: require("../assets/estimate/selected/user-content/3.svg"),
                img: require("../assets/estimate/not-selected/user-content/3.svg")
              },
              {
                name: "User Profiles",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-content/4.svg"),
                selected: require("../assets/estimate/selected/user-content/4.svg"),
                img: require("../assets/estimate/not-selected/user-content/4.svg")
              },
              {
                name: "Transactional Emails",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-content/5.svg"),
                selected: require("../assets/estimate/selected/user-content/5.svg"),
                img: require("../assets/estimate/not-selected/user-content/5.svg")
              },
              {
                name: "Audio/Video Processing",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-content/6.svg"),
                selected: require("../assets/estimate/selected/user-content/6.svg"),
                img: require("../assets/estimate/not-selected/user-content/6.svg")
              },
              {
                name: "Free text searching",
                select: false,
                not_selected: require("../assets/estimate/not-selected/user-content/7.svg"),
                selected: require("../assets/estimate/selected/user-content/7.svg"),
                img: require("../assets/estimate/not-selected/user-content/7.svg")
              }
            ]
          },
          {
            name: "Dates & Locations",
            select_all: true,
            option: [
              {
                name: "Calendar",
                select: false,
                not_selected: require("../assets/estimate/not-selected/date-location/1.svg"),
                selected: require("../assets/estimate/selected/date-location/1.svg"),
                img: require("../assets/estimate/not-selected/date-location/1.svg")
              },
              {
                name: "Display of Map data / Geolocation",
                select: false,
                not_selected: require("../assets/estimate/not-selected/date-location/2.svg"),
                selected: require("../assets/estimate/selected/date-location/2.svg"),
                img: require("../assets/estimate/not-selected/date-location/2.svg")
              },
              {
                name: "Display of custom map markers / regions",
                select: false,
                not_selected: require("../assets/estimate/not-selected/date-location/3.svg"),
                selected: require("../assets/estimate/selected/date-location/3.svg"),
                img: require("../assets/estimate/not-selected/date-location/3.svg")
              },
              {
                name: "Booking",
                select: false,
                not_selected: require("../assets/estimate/not-selected/date-location/4.svg"),
                selected: require("../assets/estimate/selected/date-location/4.svg"),
                img: require("../assets/estimate/not-selected/date-location/4.svg")
              }
            ]
          },
          {
            name: "Social & Engagement",
            select_all: true,
            option: [
              {
                name: "Messaging",
                select: false,
                not_selected: require("../assets/estimate/not-selected/social/1.svg"),
                selected: require("../assets/estimate/selected/social/1.svg"),
                img: require("../assets/estimate/not-selected/social/1.svg")
              },
              {
                name: "Forums or commenting",
                select: false,
                not_selected: require("../assets/estimate/not-selected/social/2.svg"),
                selected: require("../assets/estimate/selected/social/2.svg"),
                img: require("../assets/estimate/not-selected/social/2.svg")
              },
              {
                name: "Social Sharing",
                select: false,
                not_selected: require("../assets/estimate/not-selected/social/3.svg"),
                selected: require("../assets/estimate/selected/social/3.svg"),
                img: require("../assets/estimate/not-selected/social/3.svg")
              }
            ]
          },
          {
            name: "Billing & eCommerce",
            select_all: true,
            option: [
              {
                name: "Subscription Plans",
                select: false,
                not_selected: require("../assets/estimate/not-selected/billing/1.svg"),
                selected: require("../assets/estimate/selected/billing/1.svg"),
                img: require("../assets/estimate/not-selected/billing/1.svg")
              },
              {
                name: "Payment processing",
                select: false,
                not_selected: require("../assets/estimate/not-selected/billing/2.svg"),
                selected: require("../assets/estimate/selected/billing/2.svg"),
                img: require("../assets/estimate/not-selected/billing/2.svg")
              },
              {
                name: "Shopping Cart",
                select: false,
                not_selected: require("../assets/estimate/not-selected/billing/3.svg"),
                selected: require("../assets/estimate/selected/billing/3.svg"),
                img: require("../assets/estimate/not-selected/billing/3.svg")
              },
              {
                name: "Product Management",
                select: false,
                not_selected: require("../assets/estimate/not-selected/billing/4.svg"),
                selected: require("../assets/estimate/selected/billing/4.svg"),
                img: require("../assets/estimate/not-selected/billing/4.svg")
              }
            ]
          },
          {
            name: "Admin, Feedback & Analytics",
            select_all: true,
            option: [
              {
                name: "CMS Integration",
                select: false,
                not_selected: require("../assets/estimate/not-selected/admin-feedback-analytics/1.svg"),
                selected: require("../assets/estimate/selected/admin-feedback-analytics/1.svg"),
                img: require("../assets/estimate/not-selected/admin-feedback-analytics/1.svg")
              },
              {
                name: "User Admin pages",
                select: false,
                not_selected: require("../assets/estimate/not-selected/admin-feedback-analytics/2.svg"),
                selected: require("../assets/estimate/selected/admin-feedback-analytics/2.svg"),
                img: require("../assets/estimate/not-selected/admin-feedback-analytics/2.svg")
              },
              {
                name: "Moderation / Content Approval",
                select: false,
                not_selected: require("../assets/estimate/not-selected/admin-feedback-analytics/3.svg"),
                selected: require("../assets/estimate/selected/admin-feedback-analytics/3.svg"),
                img: require("../assets/estimate/not-selected/admin-feedback-analytics/3.svg")
              },
              {
                name: "Usage Analytics",
                select: false,
                not_selected: require("../assets/estimate/not-selected/admin-feedback-analytics/4.svg"),
                selected: require("../assets/estimate/selected/admin-feedback-analytics/4.svg"),
                img: require("../assets/estimate/not-selected/admin-feedback-analytics/4.svg")
              },
              {
                name: "Crash Reporting",
                select: false,
                not_selected: require("../assets/estimate/not-selected/admin-feedback-analytics/5.svg"),
                selected: require("../assets/estimate/selected/admin-feedback-analytics/5.svg"),
                img: require("../assets/estimate/not-selected/admin-feedback-analytics/5.svg")
              },
              {
                name: "Performance Monitoring",
                select: false,
                not_selected: require("../assets/estimate/not-selected/admin-feedback-analytics/6.svg"),
                selected: require("../assets/estimate/selected/admin-feedback-analytics/6.svg"),
                img: require("../assets/estimate/not-selected/admin-feedback-analytics/6.svg")
              }
            ]
          },
          {
            name: "Security",
            select_all: true,
            option: [
              {
                name: "SSL Certificate based Security",
                select: false,
                not_selected: require("../assets/estimate/not-selected/security/1.svg"),
                selected: require("../assets/estimate/selected/security/1.svg"),
                img: require("../assets/estimate/not-selected/security/1.svg")
              },
              {
                name: "DoS protection",
                select: false,
                not_selected: require("../assets/estimate/not-selected/security/2.svg"),
                selected: require("../assets/estimate/selected/security/2.svg"),
                img: require("../assets/estimate/not-selected/security/2.svg")
              }
            ]
          },
          {
            name: "Do you want to digitise your paper base data?",
            select_all: false,
            option: [
              {
                name: "Yes",
                select: false,
                not_selected: require("../assets/estimate/not-selected/do-you-want-to-digitise/1.svg"),
                selected: require("../assets/estimate/selected/do-you-want-to-digitise/1.svg"),
                img: require("../assets/estimate/not-selected/do-you-want-to-digitise/1.svg")
              },
              {
                name: "No",
                select: false,
                not_selected: require("../assets/estimate/not-selected/do-you-want-to-digitise/2.svg"),
                selected: require("../assets/estimate/selected/do-you-want-to-digitise/2.svg"),
                img: require("../assets/estimate/not-selected/do-you-want-to-digitise/2.svg")
              }
            ]
          },
          {
            name: "Integration with",
            select_all: true,
            option: [
              {
                name: "Dropbox",
                select: false,
                not_selected: require("../assets/estimate/not-selected/intigrate-with/1.svg"),
                selected: require("../assets/estimate/selected/intigrate-with/1.svg"),
                img: require("../assets/estimate/not-selected/intigrate-with/1.svg")
              },
              {
                name: "Quickbooks",
                select: false,
                not_selected: require("../assets/estimate/not-selected/intigrate-with/2.svg"),
                selected: require("../assets/estimate/selected/intigrate-with/2.svg"),
                img: require("../assets/estimate/not-selected/intigrate-with/2.svg")
              }
            ]
          }
        ]
      },
      actual: {
        type: [
          {
            name: "website",
            select: false
          },
          {
            name: "IOS",
            select: false
          },
          {
            name: "Android",
            select: false
          }
        ],
        other: [
          {
            name: "How big is your Company?",
            option: [
              {
                name: "Small",
                select: false
              },
              {
                name: "Medium",
                select: false
              },
              {
                name: "Large",
                select: false
              }
            ]
          },
          {
            name: "Do you want custom branding?",
            option: [
              {
                name: "Yes",
                select: false
              },
              {
                name: "No",
                select: false
              }
            ]
          },
          {
            name: "Users & Accounts",
            option: [
              {
                name: "E-mail",
                select: false
              },
              {
                name: "Facebook",
                select: false
              },
              {
                name: "Twitter",
                select: false
              },
              {
                name: "Single Sign On",
                select: false
              },
              {
                name: "Google Sign Up",
                select: false
              },
              {
                name: "Apple",
                select: false
              },
              {
                name: "Microsoft",
                select: false
              },
              {
                name: "Phone",
                select: false
              }
            ]
          },
          {
            name: "User Generated Content",
            option: [
              {
                name: "Dashboard",
                select: false
              },
              {
                name: "Activity Feed",
                select: false
              },
              {
                name: "File Upload",
                select: false
              },
              {
                name: "User Profiles",
                select: false
              },
              {
                name: "Transactional Emails",
                select: false
              },
              {
                name: "Audio/Video Processing",
                select: false
              },
              {
                name: "Free text searching",
                select: false
              }
            ]
          },
          {
            name: "Dates & Locations",
            option: [
              {
                name: "Calendar",
                select: false
              },
              {
                name: "Display of Map data / Geolocation",
                select: false
              },
              {
                name: "Display of custom map markers / regions",
                select: false
              },
              {
                name: "Booking",
                select: false
              }
            ]
          },
          {
            name: "Social & Engagement",
            option: [
              {
                name: "Messaging",
                select: false
              },
              {
                name: "Forums or commenting",
                select: false
              },
              {
                name: "Social Sharing",
                select: false
              }
            ]
          },
          {
            name: "Billing & eCommerce",
            option: [
              {
                name: "Subscription Plans",
                select: false
              },
              {
                name: "Payment processing",
                select: false
              },
              {
                name: "Shopping Cart",
                select: false
              },
              {
                name: "Product Management",
                select: false
              }
            ]
          },
          {
            name: "Admin, Feedback & Analytics",
            option: [
              {
                name: "CMS Integration",
                select: false
              },
              {
                name: "User Admin pages",
                select: false
              },
              {
                name: "Moderation / Content Approval",
                select: false
              },
              {
                name: "Usage Analytics",
                select: false
              },
              {
                name: "Crash Reporting",
                select: false
              },
              {
                name: "Performance Monitoring",
                select: false
              }
            ]
          },
          {
            name: "Security",
            option: [
              {
                name: "SSL Certificate based Security",
                select: false
              },
              {
                name: "DoS protection",
                select: false
              }
            ]
          },
          {
            name: "Do you want to digitise your paper base data?",
            option: [
              {
                name: "Yes",
                select: false
              },
              {
                name: "No",
                select: false
              }
            ]
          },
          {
            name: "Integration with",
            option: [
              {
                name: "Dropbox",
                select: false
              },
              {
                name: "Quickbooks",
                select: false
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    update_images(data, index, value, option_index) {
      if (value != "other")
        if (data.select == true) {
          this.estimate[value][index].select = false;
          this.estimate[value][index].img = data.not_selected;
          //actule
          this.actual[value][index].select = false;
          this.$root.toast(data.name + " " + "deselected");
        } else {
          this.estimate[value][index].select = true;
          this.estimate[value][index].img = data.selected;
          //actule
          this.actual[value][index].select = true;
          this.$root.toast(data.name + " " + "selected");
        }
      else {
        if (data.select_all == true) {
          if (data.option[option_index].select == true) {
            // console.log("select");
            this.estimate[value][index].option[option_index].select = false;
            this.estimate[value][index].option[option_index].img =
              data.option[option_index].not_selected;
            //actule
            this.actual[value][index].option[option_index].select = false;
            this.$root.toast(
              data.option[option_index].name + " " + "deselected"
            );
          } else {
            this.estimate[value][index].option[option_index].select = true;
            this.estimate[value][index].option[option_index].img =
              data.option[option_index].selected;
            //actule
            this.actual[value][index].option[option_index].select = true;
            this.$root.toast(data.option[option_index].name + " " + "selected");
          }
        } else {
          if (data.option[option_index].select == true) {
            // console.log("select");
            this.estimate[value][index].option[option_index].select = false;
            this.estimate[value][index].option[option_index].img =
              data.option[option_index].not_selected;
            //actule
            this.actual[value][index].option[option_index].select = false;
            this.$root.toast(
              data.option[option_index].name + " " + "deselected"
            );
          } else {
            for (
              let loop_index = 0;
              loop_index < this.estimate[value][index].option.length;
              loop_index++
            ) {
              this.estimate[value][index].option[loop_index].select = false;
              this.estimate[value][index].option[loop_index].img =
                data.option[loop_index].not_selected;
              //actule
              this.actual[value][index].option[loop_index].select = false;
            }
            this.estimate[value][index].option[option_index].select = true;
            this.estimate[value][index].option[option_index].img =
              data.option[option_index].selected;
            //actule
            this.actual[value][index].option[option_index].select = true;
            this.$root.toast(data.option[option_index].name + " " + "selected");
          }
        }
      }
    },
    email_validate() {
      let email = this.userdata.email;
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let test = re.test(email);
      if (test == true) {
        this.validate.email = false;
      } else {
        this.validate.email = true;
      }
    },
    checkData() {
      if (!this.actual) {
        return false;
      } else {
        let type_selected = false;
        for (
          let index_type = 0;
          index_type < this.actual.type.length;
          index_type++
        ) {
          if (this.actual.type[index_type].select == true) {
            type_selected = true;
          }
        }
        this.validate.type_selected = type_selected;
      }
    },
    handleOk() {
      this.$root.toast(
        this.userdata.name +
          " Thanks for Query we will let you know as soon as posbile"
      );
      location.reload();
    },
    submit() {
      this.loading = true;
      this.checkData();
      if (
        this.validate.type_selected == true &&
        this.userdata.email &&
        this.userdata.name
      ) {
        let data_type = "<b> Work Type </b> <br/>";
        let data_other = "<b> Other Details </b> <br/>";
        let first_line = "<b>User Details</b> <br/>";
        let email_user_data =
          "Name: " +
          this.userdata.name +
          "<br/>" +
          "Email: " +
          this.userdata.email;
        for (
          let index_type = 0;
          index_type < this.actual.type.length;
          index_type++
        ) {
          if (this.actual.type[index_type].select == true) {
            data_type += this.actual.type[index_type].name + "<br/>";
          }
        }
        for (
          let index_other = 0;
          index_other < this.actual.other.length;
          index_other++
        ) {
          let other_options = "";

          for (
            let options_type = 0;
            options_type < this.actual.other[index_other].option.length;
            options_type++
          ) {
            if (
              this.actual.other[index_other].option[options_type].select == true
            )
              other_options +=
                this.actual.other[index_other].option[options_type].name + ",";
          }
          data_other +=
            "<b>" +
            index_other +
            "." +
            this.actual.other[index_other].name +
            "</b><br/>" +
            other_options +
            "<br/>";
        }
        // console.log(first_line + " " + email_user_data + "\n" + data_other);
        dbFs
          .collection("mail")
          .add({
            to: "info@drillmaps.com",
            message: {
              subject: "Estimate My Project Query from " + this.userdata.name,
              html:
                first_line +
                " " +
                email_user_data +
                "<br/>" +
                data_type +
                data_other
            }
          })
          .then(data => {
            console.log(data);
            this.$root.toast(
              this.userdata.name +
                " Thanks for Query we will let you know as soon as posbile"
            );
            window.scrollTo(0, 0);
            this.modalShow = true;
            // location.reload();
          })
          .catch(error => {
            console.log(error);
            this.$root.toast(
              this.userdata.name +
                "we found some problem please connect us to later"
            );
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        window.scrollTo(0, 0);
        alert("Please Select your Platform");
      }
    }
  }
};
</script>

<style scoped>
.heading {
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.heading p {
  margin: 0px;
}
.estimate {
  background-color: #272727;
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  /* margin-left: 120px;
  margin-right: 120px; */
}
.br {
  width: 100px;
  height: 4px;
  margin: auto;
  background-color: #00a8ff;
  align-items: center;
}
.box {
  margin: auto;
  margin-top: 30px;
}
.box-1 {
  border-bottom: 6px solid #00a8ff;
  /* padding: 20px; */
}
.box-2 {
  /* border: 4px solid #00a8ff; */
  border-top: 6px solid #00a8ff;
  border-bottom: 6px solid #00a8ff;
  border-left: 12px solid #00a8ff;
  border-right: 12px solid #00a8ff;
}
.box-3 {
  border-top: 6px solid #00a8ff;
  padding-top: 30px;
  padding-bottom: 50px;
}
.box-4 {
  border-top: 12px solid #00a8ff;
  /* border-bottom: 6px solid #00a8ff; */
  border-left: 12px solid #00a8ff;
  border-right: 12px solid #00a8ff;
  padding-top: 40px;
  padding-bottom: 50px;
}
.e_icon {
  height: 61px;
  width: 66px;
  padding: 10px;
  margin: auto;
  /* margin-left: 5px; */
}
.e_title {
  margin: auto;
  padding: 10px;
  font-weight: bold;
  font-size: 25px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.e_paragraph {
  /* margin: auto; */
  /* padding: 10px; */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.box_heading {
  padding: 10px;
  margin-top: 10px;
  font-size: 25px;
  padding: 10px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.box_other {
  /* margin: auto; */
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
.other_img {
  height: 150px;
  width: 150px;
  padding: 10px;
  padding-bottom: 0px;
  /* margin: auto; */
}
.img_text {
  font-size: 12px;
  padding-bottom: 10px;
  /* text-align: center; */
}
.square {
  border-radius: 0;
}
</style>
